import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    commentSection: {
        "&:hover $editIconButton": {
            opacity: 1,
            color: "inherit",
        },
    },
    avatarWrapper: {
        display: "flex",
        gap: theme.spacing(4),
        alignItems: "center",
        position: "relative",
    },
    nameAndDateWrapper: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
    },
    avatarName: {
        fontFamily: "Source Sans 3",
        fontWeight: 700,
        fontSize: "14px",
    },
    dateWrapper: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
    },
    avatarDate: {
        fontFamily: "Source Sans 3",
        fontWeight: 400,
        fontSize: "11px",
    },
    editedBadge: {
        fontFamily: "Source Sans 3",
        fontWeight: 700,
        fontSize: "10px",
        color: "white",
        backgroundColor: theme.palette.info.main,
        padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
        borderRadius: theme.spacing(1.5),
        textTransform: "uppercase",
        letterSpacing: "0.5px",
    },
    commentText: {
        fontFamily: "Source Sans 3",
        fontWeight: 400,
        fontSize: "14px",
        marginTop: theme.spacing(2),
    },
    editIconWrapper: {
        marginLeft: "auto",
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(0.5),
    },
    editIconButton: {
        padding: theme.spacing(1),
        opacity: 0.3,
        transition: "opacity 0.2s ease-in-out",
        "&:hover": {
            opacity: 1,
        },
    },
}));
